/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { UtilityComponentsModule } from 'src/app/common/utility-components/utility-components.module';

import { EnterpriseDashboardRoutingModule } from './enterprise-dashboard-routing.module';
import { EnterpriseDashboardComponent } from './enterprise-dashboard.component';
import { EnterpriseDashboardService } from './enterprise-dashboard.service';

@NgModule({
	declarations: [EnterpriseDashboardComponent],
	imports: [CommonModule, FormsModule, EnterpriseDashboardRoutingModule, UtilityComponentsModule],
	providers: [EnterpriseDashboardService, { provide: Window, useValue: window }],
	exports: [EnterpriseDashboardComponent],
})
export class EnterpriseDashboardModule {}
